import { render, staticRenderFns } from "./Emergency.vue?vue&type=template&id=6c78f019&scoped=true&"
import script from "./Emergency.vue?vue&type=script&lang=js&"
export * from "./Emergency.vue?vue&type=script&lang=js&"
import style0 from "./Emergency.vue?vue&type=style&index=0&id=6c78f019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c78f019",
  null
  
)

export default component.exports